// src/data/actions/cart.js

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const UPDATE_CART_QTY = "UPDATE_CART_QTY";
export const CLEAR_CART = "CLEAR_CART";

// 🔥 helper for final price
//const getFinalPrice = (product) => {
 // if (product.isOnSale && product.discountPercent > 0) {
   // return product.price - (product.price * product.discountPercent) / 100;
 // }
  //return product.price;
//};

export const addToCart = (product) => (dispatch) => {

  const finalPrice =
    product.finalPrice ||
    (product.isOnSale && product.discountPercent > 0
      ? product.price - (product.price * product.discountPercent) / 100
      : product.price);

  dispatch({
    type: ADD_TO_CART,
    payload: {
      product: String(product.product || product._id),
      name: product.name,
      price: product.price,
      finalPrice,
      photo: product.photo,
      size: product.size,
      color: product.color,
      quantity: product.quantity || 1,
    },
  });
};
export const removeFromCart = (id, size, color) => {
  return {
    type: REMOVE_FROM_CART,
    payload: { id, size, color }, // ✅ FIX (variant-based)
  };
};

export const updateCartQty = (id, qty, size, color) => {
  return {
    type: UPDATE_CART_QTY,
    payload: { id, qty, size, color }, // ✅ FIX
  };
};

export const clearCart = () => {
  return { type: CLEAR_CART };
};